import { Check } from "@mui/icons-material";
import { Button } from "@mui/material";

export interface StatusProps {
  title: string;
  status: "success" | "warning" | "error";
}
export default function Status({ status, title }: StatusProps) {
  const bgColors = {
    success: "#E7F5E9",
    warning: "",
    error: "",
  };
  const colors = {
    success: "#24AF22",
    warning: "",
    error: "",
  };
  return (
    <Button style={{ backgroundColor: bgColors[status], gap: 4 }}>
      <span style={{ color: colors[status] }}>
        <Check />
      </span>
      <span style={{ color: colors[status] }}>{title}</span>
    </Button>
  );
}
